export const VIEW_TERM_DATA = 'VIEW_TERM_DATA';
export const ADD_TERM_DATA = 'ADD_TERM_DATA';
export const ADD_DATA_ERROR = 'ADD_DATA_ERROR';
export const RESET_TERM_DATA = 'TERM_DATA_RESET';
export const LOAD_TERM_DATA = 'LOAD_TERM_DATA';
export const LOAD_TERM_DATA_SUCCESS = 'LOAD_TERM_DATA_SUCCESS';
export const LOAD_TERM_DATA_ERROR = 'LOAD_TERM_DATA_ERROR';
export const SET_ERROR_CLOSE = 'SET_ERROR_CLOSE';
export const LOAD_SUBTERM_DATA_SUCCESS = 'LOAD_SUBTERM_DATA_SUCCESS';
export const LOAD_SUBTERM_DATA = 'LOAD_SUBTERM_DATA';
export const ADD_TERM_SUBTERM_DATA = 'ADD_TERM_SUBTERM_DATA';
export const SET_SELECTED_TERM = 'SELECTED_TERM_DATA';
export const SET_SELECTED_SUBTERM = 'SELECTED_SUBTERM_DATA';
export const RESET_SELECTED_TERM = 'RESET_SELECTED_TERM_DATA';
export const RESET_SELECTED_SUBTERM = 'RESET_SELECTED_SUBTERM_DATA';
export const RESET_SUBTERM_DATA = 'RESET_SUBTERM_DATA';